class ReconFeatureTable extends HTMLElement {
	constructor() {
		super();
		console.log("ReconFeatureTable :: Constructor");
		this.serverUrl = this.getServerUrl();
		this.els = {
			tableBody: null,
			tableHead: null,
			customerDataBar: null,
		};
		this.fetchFeaturesTable = this.fetchFeaturesTable.bind(this);
	}

	// getServerUrl() {
	//   const { apiRoots, environment } = window.api;
	//   return apiRoots[environment] || apiRoots.production;
	// }
	getServerUrl() {
		return "/apps/recon-loyalty-api/";
		// const ctx = this.getCtx();
		// const apiRoot = ctx?.environment === "dev" ? ctx?.devUrl : ctx?.prodUrl || "";
		// if (!apiRoot) {
		//   throw new Error("API root not found");
		// }
		// return apiRoot;
	}


	connectedCallback() {
		this.els.tableBody = this.querySelector(".app--rank-table-body");
		this.els.tableHead = this.querySelector(".app--rank-table-head");
		this.els.customerDataBar = document.querySelector("[GRLA-banner-customer-data]");
		this.fetchFeaturesTable();
	}

	getCtx() {
		return window.reConLoyaltyProgram || {};
	}

	async fetchFeaturesTable() {
		try {
			const ctx = this.getCtx();
			if (!ctx.shopDomain) return;

			const params = new URLSearchParams({
				shopDomain: ctx.shopDomain,
			});

			// console.log({ params }, "fetchFeaturesTable :: Params");
			const resp = await fetch(`${this.serverUrl}feature-table?${params.toString()}`);
			const payload = await resp.json();
			console.log({ payload }, "fetchFeaturesTable :: Payload");
			if (payload?.statusCode !== 200) {
				return;
			}
			const data = payload?.data || [];
			console.log({ data }, "fetchFeaturesTable :: Tiers");
			this.renderFeaturesTable(data);
			this.renderCustomerData({ customerTier: data?.customerTier ?? null, badgeIcons: data?.badgeIcons });
			// return data;
		} catch (error) {
			console.error({ error }, "fetchFeaturesTable :: Error");
		}
	}

	renderFeaturesTable(data) {
		if (!this.els.tableBody || !this.els.tableHead) return;

		const customerTier = data.customerTier;
		const badgeIcons = data.badgeIcons;
		const ctx = this.getCtx();
		const isLoggedIn = Boolean(ctx?.customerEmail || ctx?.customerId);
		const tiers = Array.isArray(data?.tiers) ? data.tiers : [];

		// Try robust matching of current tier (by id, nested id, or title)
		let currentTierIndex = -1;
		if (isLoggedIn && customerTier && tiers.length) {
			const targetId = customerTier?.tierId ?? customerTier?.tier?.id;
			const targetTitle = customerTier?.tier?.title;
			currentTierIndex = tiers.findIndex(t => {
				const sameId = targetId != null && String(t.id) === String(targetId);
				const sameNestedId = customerTier?.tier?.id != null && String(t.id) === String(customerTier.tier.id);
				const sameTitle = targetTitle && t.title === targetTitle;
				return sameId || sameNestedId || sameTitle;
			});
		}
		const currentPointsValue = Number(customerTier?.rollingPoints || 0);

		const tickIconString = `<svg width="16" height="13" viewBox="0 0 16 13" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.75 8.25024C0.75 8.25024 2.25 8.25024 4.25 11.7502C4.25 11.7502 9.809 2.58324 14.75 0.750244" stroke="#AA0000" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>`
		let headHTML = `<tr><th colspan="2"></th>`;

		tiers.forEach((tier, index) => {
			const isCurrentTier = currentTierIndex >= 0 && index === currentTierIndex;
			const isNextTier = currentTierIndex >= 0 && index === currentTierIndex + 1;
			const isBeforeCurrentTier = currentTierIndex >= 0 && index < currentTierIndex;

			// const isCurrentTier = currentPointsValue >= tier.entryPoints;
			// TODO: Handle the case when the customer is not logged in
			const headText = isLoggedIn && isCurrentTier
				? "Current Tier"
				: (isLoggedIn && isNextTier
					? `${currentPointsValue.toLocaleString()}/${(tier.entryPoints ?? 0).toLocaleString()}`
					: ((tier.entryPoints ?? 0).toLocaleString())
				);

			// Calculate progress width based on tier position
			let progressWidth = 0;
			if (!isLoggedIn) {
				progressWidth = 100;
			} else if (isCurrentTier) {
				progressWidth = 100;
			} else if (isNextTier) {
				const nextEntry = Number(tier.entryPoints ?? 0);
				progressWidth = nextEntry > 0 ? (currentPointsValue / nextEntry) * 100 : 0;
			} else if (isBeforeCurrentTier) {
				progressWidth = 100;
			}
			progressWidth = Math.max(0, Math.min(100, progressWidth));

			headHTML += `
			<th>
				<div class="app--rank-head">
					<div class="app--rank-head-progress" style="width: ${progressWidth}%"></div>
					<div class="app--rank-head-text">
					${headText}
					</div>
				</div>
				
				<img src="${this.getBadgeIconUrl(badgeIcons, tier.icon, tier.customIcon?.url)}" width="80">
				<p class="app--rank-head-benifits">BENEFITS</p>
			</th>
			`;
		});

		// <p class="app--rank-title">${tier.title}</p>
		headHTML += `</tr>`;
		this.els.tableHead.innerHTML = headHTML;

		let bodyHTML = "";

		data.benefits.forEach((benefit, index) => {
			const isLast = index === data.benefits.length - 1;

			bodyHTML += `
				<tr class="${isLast ? "final-row" : ""}">
					<td colspan="2" class="feature">${benefit.label}</td>
			`;

			tiers.forEach(tier => {
				const hasFeature = tier.features[benefit.id] === true;

				bodyHTML += `
					<td class="${isLast ? "final-cell" : ""}">
						${hasFeature ? `<span class="tick">${tickIconString}</span>` : ""}
					</td>
				`;
			});

			bodyHTML += `</tr>`;
		});

		this.els.tableBody.innerHTML = bodyHTML;
	}

	renderCustomerData(data) {
		const { customerTier, badgeIcons } = data ?? {};
		if (!customerTier) {
			return false
		}
		// console.log("customerDataBar", this.els.customerDataBar);
		// console.log("customerDataBar", customerTier, badgeIcons);
		const tierBadge = badgeIcons[customerTier?.tier?.icon];
		const tempHTML = `
		<div class="GRLA__hero_banner_customer_data--inner">
			<img class="GRLA__hero_banner_customer_data--inner--bg" src="https://cdn.shopify.com/s/files/1/0848/9438/4420/files/red-bg-brushedtexture-2050x160.png?v=1765238463">
			<div class="GRLA__hero_banner_customer_data--points">
				<h3>Your Points:</h3> <span>${customerTier?.currentPoints?.toLocaleString() || 0}</span>
			</div>
			<div class="GRLA__hero_banner_customer_data--divider"></div>
			<div class="GRLA__hero_banner_customer_data--tier">
				<h3>Your Current Tier:</h3> <span>${customerTier?.tier?.title || "-"}</span>
				<img src="${tierBadge}" />
			</div>
		</div>
		`;

		// console.log("tempHTML", tempHTML)
		this.els.customerDataBar.innerHTML = tempHTML;
	}

	getBadgeIconUrl(badgeIcons, iconName, customIcon) {
		console.log({ badgeIcons, iconName }, "getBadgeIconUrl :: Badge Icons");
		if (iconName === "CUSTOM") {
			return customIcon;
		}
		return badgeIcons[iconName] || "";
	}
}

customElements.define("app-rank-table", ReconFeatureTable);

// function defineReconElement() {
//   if (customElements.get("app-rank-table")) return;
// }

// if (window.reconLiquidReady) {
//   defineReconElement();
// } else {
//   window.addEventListener('recon:liquid-ready', defineReconElement, { once: true });
// }